module.exports = __webpack_public_path__ + "static/media/Lox_meat_pie.c54ecfb9.png";